import React, { useState, useRef, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useI18n } from '../../context/I18nContext';

export const LanguageToggle: React.FC = () => {
  const { language, setLanguage } = useI18n();
  const [isSwitching, setIsSwitching] = useState(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  const handleToggle = (target: 'en' | 'ar') => {
    if (language === target || isSwitching) return;

    setIsSwitching(true);

    // Delay the actual language change so the pill animates first
    timeoutRef.current = setTimeout(() => {
      setLanguage(target);
      setIsSwitching(false);
    }, 280);
  };

  const isArabic = language === 'ar';

  return (
    <div className="relative flex items-center">
      <button
        onClick={() => handleToggle(isArabic ? 'en' : 'ar')}
        className="relative flex items-center h-9 w-[72px] rounded-xl bg-base-100 dark:bg-base-800 border border-base-200 dark:border-base-700 overflow-hidden transition-colors duration-200 hover:border-base-300 dark:hover:border-base-600 active:scale-95"
        aria-label={isArabic ? 'Switch to English' : 'التبديل إلى العربية'}
      >
        {/* Sliding indicator */}
        <motion.div
          className="absolute top-0.5 bottom-0.5 w-[34px] rounded-lg bg-accent-600 shadow-sm"
          initial={false}
          animate={{
            left: isArabic ? 'calc(100% - 36px)' : '2px',
          }}
          transition={{
            type: 'spring',
            stiffness: 500,
            damping: 30,
          }}
        />

        {/* EN label */}
        <span
          className={`relative z-10 flex items-center justify-center w-[34px] h-full text-xs font-bold transition-colors duration-200 ${
            !isArabic ? 'text-white' : 'text-base-500 dark:text-base-400'
          }`}
        >
          A
        </span>

        {/* AR label */}
        <span
          className={`relative z-10 flex items-center justify-center w-[34px] h-full text-sm font-bold transition-colors duration-200 ${
            isArabic ? 'text-white' : 'text-base-500 dark:text-base-400'
          }`}
        >
          ع
        </span>
      </button>
    </div>
  );
};
